<template>
  <BaseView>
    <div class="bg-white">
      <Breadcrumbs />

      <div class="py-[40px] md:py-[0px] -mt-10">
        <GorgiasContactForm class="m-auto md:w-50% px-[20px]" />
      </div>

      <div class="py-5 pb-16 px-[20px]">
        <div class="max-w-screen-xs mx-auto flex flex-col gap-y-3 items-center justify-center">
          <div class="inline-flex justify-center items-center gap-x-6">
            <a
              :key="index"
              :href="social.url"
              target="_blank"
              v-for="(social, index) in socialIcons">
              <component
                :is="social.icon.svg"
                :fill1="social.icon.fill1"
                class="size-8 cursor-pointer" />
            </a>
          </div>

          <p class="paragraph-1">Suite 2.01, 50 York St, Sydney, NSW 2000</p>
        </div>
      </div>
    </div>
  </BaseView>
</template>

<script lang="ts" setup>
import { useHead } from '@unhead/vue'
import BaseView from '@/views/BaseView.vue'
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs.vue'
import GorgiasContactForm from '@/components/BrandComponents/ContactUs/GorgiasContactForm.vue'
import TwitterIcon from '@/components/icons/Socials/TwitterIcon.vue'
import FBIcon from '@/components/icons/Socials/FBIcon.vue'
import LinkedInIcon from '@/components/icons/Socials/LinkedInIcon.vue'

useHead({
  title: 'Otivo, Be better off | Get in Touch',
  meta: [
    {
      name: 'description',
      content: 'Contact Otivo. Reach us via our contact form or visit our Sydney office.',
    },
    // Open Graph tags for social sharing
    { property: 'og:title', content: 'Otivo, Be better off | Get in Touch' },
    {
      property: 'og:description',
      content: 'Otivo, Be better off | Get in Touch',
    },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: 'https://www.otivo.com/contact' },
    { property: 'og:image:alt', content: 'Otivo Logo' },
    { property: 'og:site_name', content: 'Otivo' },
    // Twitter Card tags
    { name: 'twitter:card', content: 'summary' },
    { name: 'twitter:title', content: 'Otivo, Be better off | Get in Touch' },
    { name: 'twitter:description', content: 'Reach out to our team at Otivo.' },
    // Additional SEO tags
    {
      name: 'keywords',
      content: 'Otivo, be better off, financial services, contact form, financial planning, Sydney',
    },
  ],
})

const socialIcons = [
  {
    icon: {
      svg: TwitterIcon,
      fill1: 'otivo-blue',
    },
    url: 'https://twitter.com/OtivoFinancial',
  },
  {
    icon: {
      svg: FBIcon,
      fill1: 'otivo-blue',
    },
    url: 'https://www.facebook.com/OtivoFinancial',
  },
  {
    icon: {
      svg: LinkedInIcon,
      fill1: 'otivo-blue',
    },
    url: 'https://www.linkedin.com/company/otivo/',
  },
]
</script>
